import { render, staticRenderFns } from "./ProjectLogs.vue?vue&type=template&id=711f4be3&"
import script from "./ProjectLogs.vue?vue&type=script&lang=js&"
export * from "./ProjectLogs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLogs.vue?vue&type=style&index=0&id=711f4be3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports